import { render, staticRenderFns } from "./archivesClassList.vue?vue&type=template&id=ba623178&scoped=true"
import script from "./archivesClassList.vue?vue&type=script&lang=js"
export * from "./archivesClassList.vue?vue&type=script&lang=js"
import style0 from "./archivesClassList.vue?vue&type=style&index=0&id=ba623178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba623178",
  null
  
)

export default component.exports